export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-15.5ed0ae87.jpg";